import React, { } from 'react';

import { Navigate } from 'react-router-dom';
import { useApp } from '../context/app-context';

export const PublicRoute = ({ children }) => {

    const {state: {auth}} = useApp();

    return auth
        ? <Navigate to="/app" />
        : children
}